import { Col, Row } from "antd";
import React from "react";
import { useSelector } from "../../../context/AppContext";
import styled from "styled-components";
import { getMonthYear } from "../../../utils/time";
import { getProfileLocation } from "../common/util";
import ProfileAvatar from "../common/ProfileAvatar";
import { getActiveLinkedInExtRef, getProfileIconLink } from "../../../utils/profile";

const ProfileWrapper = styled.div`
  width: 100%;
  height: 170px;
  background-color: #F7F8FA;
  border-radius: 10px;
  margin: 12px 0px;
  font-size: 10px;
  padding: 5px 20px;
  overflow-y: hidden;
`;

const Summary = styled.div`
  line-height: 15px;
  font-size: 10px;
  margin: 10px 20px;
`;

const Pill = styled.div`
  display: inline-block;
  align-items: center;
  padding: 5px;
  margin: 2px 0px;
  font-size: 10px;
  color: #313131;
  background: #ffffff;
  border-radius: 50px;
`;


type SampleProfilesProps = {
  matches: any;
  matchesPrfSummary: any;
  forceLoadImages?: boolean;
}

const SampleProfiles = (props: SampleProfilesProps) => {
  const { matches, matchesPrfSummary, forceLoadImages = false } = props;
  const prfByIds = matches.profiles;
  const userState = useSelector((state: any) => state.login.user);

  const dateCompareMostRecent = (a: any, b: any) => {
    const getTime = (date_string: string) => {
      let date: string | number = date_string;
      if (!date_string) {
        date_string = new Date(0).toDateString();
      }
      if (date_string.indexOf("T") > -1) {
        date = date_string.split("T")[0];
      } else if (Number.isInteger(Number(date_string))) {
        date = Number(date_string);
      }
      return new Date(date).getTime();
    }
    // Sort by most recent date at top.
    return getTime(b.duration.start_date) - getTime(a.duration.start_date);
  };

  const goToLinkedInView = (prf: any, idx: number) => {
    if (!prf || !prf?.ext_refs || idx > 3 || !userState?.uid) {
      return;
    }
    const _li_url = getActiveLinkedInExtRef({ extRefs: prf.ext_refs })?.url || prf.candidate?.linkedin;

    if (!_li_url) {
      return;
    }

    window.open(_li_url.includes('http') ? _li_url : 'https://' + _li_url);
  }

  return (<>
    {matches.profiles && Object.keys(matchesPrfSummary).slice(0, 3).map((prf: any, idx: number) => (
      <ProfileWrapper key={prf}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <ProfileAvatar
            imageUrl={getProfileIconLink(prfByIds[prf])}
            fullName={prfByIds[prf]?.candidate?.full_name}
            imageHeight={32}
            imageWidth={32}
            fontSize={12}
            onClick={() => goToLinkedInView(prfByIds[prf], idx)}
            forceLoad={forceLoadImages}
          />
          <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
            <span style={{ fontSize: '14px', fontWeight: 700 }}>{unescape(prfByIds[prf]?.candidate?.full_name)}</span>
            <span style={{ fontSize: '12px', color: '#808080' }}>
              <i className="fa fa-map-marker" aria-hidden="true" style={{ marginRight: '5px' }}></i>
              {unescape(getProfileLocation(prfByIds[prf]))}
            </span>
          </div>
        </div>
        <Row>
          <Col span={12} style={{ borderRight: '1px solid #E0E0E0', padding: '7px'}}>
            <div>
              {prfByIds[prf]?.workexp.length > 0 && prfByIds[prf]?.workexp.sort(dateCompareMostRecent).slice(0, 3).map((exp: any, eidx: number) => (
                <React.Fragment key={`${exp?.company?.name || 'comp'}-${exp?.duration?.start_date || eidx}`}>
                  {exp.duration.to_present && (<div>
                    <span style={{ fontSize: '10px', fontWeight: 700, position: 'relative', margin: '10px 5px' }}>Current</span>
                    <Pill style={{ backgroundColor: "#CFE5FF"}}>
                      {unescape(exp.projects[0].role_and_group.title)} @{unescape(exp.company.name) || 'Unknown'} (Since {getMonthYear(exp.duration.start_date)})
                    </Pill>
                  </div>)}
                  {!exp.duration.to_present && (<div>
                    <Pill>
                      {unescape(exp.projects[0].role_and_group.title)} @{unescape(exp.company.name) || 'Unknown'} ({getMonthYear(exp.duration.start_date)} - {getMonthYear(exp.duration.end_date)})
                    </Pill>
                  </div>)}
                </React.Fragment>
              ))}
            </div>
          </Col>
          <Col span={12} style={{padding: '5px'}}>
            <div><i className="fa fa-bars" aria-hidden="true" style={{ color: '#313131', marginRight: '5px' }}></i><span style={{ fontSize: '10px', fontWeight: 700, position: 'relative', margin: '0px 5px' }}>Profile Highlight</span></div>
            <Summary  className="content" dangerouslySetInnerHTML={{ __html: unescape(matchesPrfSummary[prf].profile_summary) }} ></Summary>
          </Col>
        </Row>
      </ProfileWrapper>
    ))}
  </>);
}

export default SampleProfiles;
